/**
 * Wave Instance Service - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as waveMock from '../../mocks/wave';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  WaveInstanceDTO,
  WaveInstanceOrderDTO,
  QueryWaveInstancePageRequest,
  QueryWaveOrdersRequest,
  TriggerWaveRequest,
} from '../../types/wave/waveInstance';

/**
 * 分页查询波次实例
 */
export async function pageWaveInstances(
  params: QueryWaveInstancePageRequest
): Promise<ApiResponse<PageData<WaveInstanceDTO>>> {
  if (config.mock) {
    return waveMock.mockPageWaveInstances(params);
  }

  return httpClient.post(API_ENDPOINTS.WAVE_INSTANCE.PAGE, params);
}

/**
 * 按编号查询波次实例
 */
export async function getWaveInstanceByNo(
  waveNo: string
): Promise<ApiResponse<WaveInstanceDTO>> {
  if (config.mock) {
    return waveMock.mockGetWaveInstanceByNo(waveNo);
  }

  return httpClient.get(`${API_ENDPOINTS.WAVE_INSTANCE.BASE}/${waveNo}`);
}

/**
 * 查询波次订单
 */
export async function getWaveOrders(
  waveNo: string,
  params: QueryWaveOrdersRequest
): Promise<ApiResponse<PageData<WaveInstanceOrderDTO>>> {
  if (config.mock) {
    return waveMock.mockGetWaveOrders(waveNo, params);
  }

  return httpClient.post(`${API_ENDPOINTS.WAVE_INSTANCE.BASE}/${waveNo}/orders`, params);
}

/**
 * 触发波次
 */
export async function triggerWave(
  data: TriggerWaveRequest
): Promise<ApiResponse<WaveInstanceDTO>> {
  if (config.mock) {
    return waveMock.mockTriggerWave(data);
  }

  return httpClient.post(API_ENDPOINTS.WAVE_INSTANCE.TRIGGER, data);
}
